const manageVisibleProductName = (colorSwatch) => {
  const selectedValueId = colorSwatch.getAttribute('data-value-id')
  document.querySelectorAll('.product-color-variant').forEach(c => c.classList.remove('selected-description'));
  document.querySelector(`p[data-value-id="${selectedValueId}"]`).classList.add('selected-description');
}

const manageColorSelect = (targetValue) => {
  const colorSelect = document.querySelector('.js-select-color');
  if (colorSelect){
    const targetOption = colorSelect.querySelector(`[data-attr-value="${targetValue}"]`);
    colorSelect.value = targetOption.value;
    let changeEvent = new Event('change', {"bubbles":true});
    colorSelect.dispatchEvent(changeEvent);
  }
}

const bindEvents = () => {
  document.querySelectorAll('.product-variants .mm-color-swatch__inner').forEach(swatch => {
    swatch.addEventListener('click', (e) => {
      if(e.target) {
        manageVisibleProductName(e.target);
        manageColorSelect(e.target.value);
      }
    })
  });
} 

module.exports = {
  bindEvents: bindEvents
}